import { createAction } from 'redux-actions'

const ns = 'user-management/'

export const getCompanyUsers = createAction(`${ns}GET_COMPANY_USERS`)
export const getCompanyUsersSuccess = createAction(`${ns}GET_COMPANY_USERS_SUCCESS`)
export const getCompanyUsersFail = createAction(`${ns}GET_COMPANY_USERS_FAIL`)

export const setCompanyUsersLoading = createAction(`${ns}SET_COMPANY_USERS_LOADING`)

export const deleteUser = createAction(`${ns}DELETE_USER`)
export const bulkDeleteUsers = createAction(`${ns}BULK_DELETE_USERS`)
export const bulkDeleteUsersStart = createAction(`${ns}BULK_DELETE_USERS_START`)
export const bulkDeleteUsersSuccess = createAction(`${ns}BULK_DELETE_USERS_SUCCESS`)
export const bulkDeleteUsersFail = createAction(`${ns}BULK_DELETE_USERS_FAIL`)

export const bulkAddAdminRole = createAction(`${ns}BULK_ADD_ADMIN_ROLE`)
export const bulkAddAdminRoleStart = createAction(`${ns}BULK_ADD_ADMIN_ROLE_START`)
export const bulkAddAdminRoleSuccess = createAction(`${ns}BULK_ADD_ADMIN_ROLE_SUCCESS`)
export const bulkAddAdminRoleFail = createAction(`${ns}BULK_ADD_ADMIN_ROLE_FAIL`)

export const bulkRemoveAdminRole = createAction(`${ns}BULK_REMOVE_ADMIN_ROLE`)
export const bulkRemoveAdminRoleStart = createAction(`${ns}BULK_REMOVE_ADMIN_ROLE_START`)
export const bulkRemoveAdminRoleSuccess = createAction(`${ns}BULK_REMOVE_ADMIN_ROLE_SUCCESS`)
export const bulkRemoveAdminRoleFail = createAction(`${ns}BULK_REMOVE_ADMIN_ROLE_FAIL`)

export const toggleUserStatus = createAction(`${ns}TOGGLE_USER_STATUS`)
export const setUserCountry = createAction(`${ns}SET_USER_COUNTRY`)

export const setUserDivision = createAction(`${ns}SET_USER_DIVISION`)
export const setUserDivisionSuccess = createAction(`${ns}SET_USER_DIVISION_SUCCESS`)
